<div class="container">
  <div class="row">
    <header><app-logo></app-logo></header>
    <main>
      <div class="banner">
        <h1 [innerHtml]="'ERROR.PROMOTION_ENDED.HEAD' | translate"></h1>
      </div> 
      
      <div class="box full-height">
        <div class="box__left">
          <p [innerHtml]="'ERROR.PROMOTION_ENDED.SUBHEAD' | translate"></p>
          <p [innerHtml]="'ERROR.PROMOTION_ENDED.DESC' | translate"></p>
          <br/>
        </div>
      </div>
    </main>
  </div>
</div>